import { setTitleByDimension } from 'shared/utils/titles'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './Legend.module.scss'

const Legend = props => {
  const { payload, dimensions } = props

  return (
    <main className={styles.wrapper}>
      {
        payload.map(
          (entry, index) => {

            const dimensionValue = entry.value.split(',')[0]
            const title = props?.customTitleDimensionMapper
              ? props?.customTitleDimensionMapper(dimensionValue)
              : setTitleByDimension(dimensionValue, dimensions)

            return (
              <div
                key={`item-${index}`}
                className={styles.item}
              >
                <div
                  className={styles.color}
                  style={{
                    background: entry.color
                  }}
                />

                <span>
                  {title}
                </span>
              </div>
            )
          }
        )
      }
    </main>
  )
}

Legend.propTypes = {
  payload: PropTypes.array,
  dimensions: PropTypes.array,
  customTitleDimensionMapper: PropTypes.func
}

export default Legend
